export const state = () => ({

})

export const getters = {

}

export const actions = {
  async removeImageFromProperty({ commit, dispatch }, { imageId, fileName, propertyId }) {
    try {
      if (!imageId && !fileName) {
        throw new Error('imageId and fileName must be specified.')
      }
      const encodedFileName = encodeURIComponent(fileName)
      const { result } = await this.$axios.$delete(
        `/images/${propertyId}/${imageId}/${encodedFileName}`
      )
      return result === 'ok'
    } catch (err) {
      return dispatch(
        'global/setNetworkError',
        { method: 'images/removeImageFromProperty', info: err },
        { root: true }
      )
    }
  },
  async setImageToPrimary({ dispatch }, { imageId, fileName, propertyId }) {
    try {
      if (!imageId && !fileName) {
        throw new Error('imageId and fileName must be specified.')
      }
      const { result } = await this.$axios.$put(
        `/images/primary/${propertyId}/${imageId}`, { fileName }
      )
      return result === 'ok'
    } catch (err) {
      return dispatch(
        'global/setNetworkError',
        { method: 'images/setImageToPrimary', info: err },
        { root: true }
      )
    }
  },
  async updateImageDescription({ dispatch }, { descriptionTx, imageId, fileName, propertyId }) {
    try {
      if (!imageId && !fileName) {
        throw new Error('imageId and fileName must be specified.')
      }
      const { result } = await this.$axios.$put(
        `/images/${propertyId}`, { imageId, descriptionTx, fileName }
      )
      return result === 'ok'
    } catch (err) {
      return dispatch(
        'global/setNetworkError',
        { method: 'images/updateImageDescription', info: err },
        { root: true }
      )
    }
  },
  async uploadImage({ dispatch }, { file, propertyId }) {
    try {
      const form = new FormData()
      form.append('image', file)
      const { result } = await this.$axios.$post(
        `/images/${propertyId}`, form,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )
      return result === 'ok' || result
    } catch (err) {
      return dispatch(
        'global/setNetworkError',
        { method: 'images/uploadImage', info: err },
        { root: true }
      )
    }
  },
  async uploadMultipleImages({ dispatch }, { files, propertyId, onProgress }) {
    try {
      const results = []
      
      // Upload files sequentially to avoid conflicts
      for (let index = 0; index < files.length; index++) {
        const file = files[index]
        
        // Call progress callback if provided
        if (onProgress) {
          onProgress({ current: index + 1, total: files.length, fileName: file.name })
        }
        
        try {
          const form = new FormData()
          form.append('image', file)
          const { result } = await this.$axios.$post(
            `/images/${propertyId}`, form,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          )
          results.push({
            index: index + 1,
            fileName: file.name,
            success: result === 'ok',
            result: result === 'ok' || result
          })
        } catch (err) {
          results.push({
            index: index + 1,
            fileName: file.name,
            success: false,
            error: err.response?.data?.message || err.message || 'Upload failed'
          })
        }
        
        // Add a small delay between uploads to prevent server conflicts
        if (index < files.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 200))
        }
      }

      return results
    } catch (err) {
      return dispatch(
        'global/setNetworkError',
        { method: 'images/uploadMultipleImages', info: err },
        { root: true }
      )
    }
  }
}

export const mutations = {

}
